import { render, staticRenderFns } from "./ShoppingPickupList.vue?vue&type=template&id=0979e9d1&"
import script from "./ShoppingPickupList.vue?vue&type=script&lang=js&"
export * from "./ShoppingPickupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports